import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Thumb/Shop';
import s from './Commission.scss';
const CommissionThumbReactView = (props)=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(MinimalDumbo, _extends({}, props)));
CommissionThumbReactView.displayName = 'CommissionThumbReactView';
export default CommissionThumbReactView;
